import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import Form, { ButtonItem, SimpleItem, EmptyItem, GroupItem, ColCountByScreen, Label } from 'devextreme-react/form'
import JumboCardQuick from '@jumbo/components/JumboCardQuick'
import { useSelector } from 'react-redux'
import Typography from '@mui/material/Typography'
import { IconButton, Stack, useMediaQuery } from '@mui/material'
import WestIcon from '@mui/icons-material/West'

const AddAgeGroupForm = (props) => {
    const navigate = useNavigate()
    const { handleSubmit } = useForm()
    const { loading } = useSelector((state) => state.ageGroups)
    const [labelLocation, setLabelLocation] = useState('left')
    const sm = useMediaQuery('(max-width:600px)')

    useEffect(() => {
        setLabelLocation(sm ? 'top' : 'left')
    }, [sm])

    const submitButtonOptions = {
        text: 'Save',
        type: 'default',
        width: 120,
        useSubmitBehavior: true,
    }

    const cancelButtonOptions = {
        text: 'Cancel',
        type: 'Normal',
        width: 120,
        onClick: () =>
            navigate('/settings/definitions/age-group', {
                state: { navigateFrom: 'cancel-add-age-group' },
            }),
    }

    const validationRules = {
        ageGroupName: [{ type: 'required', message: 'Age Group Name is required.' }],
        ageStart: [{ type: 'required', message: 'Age Start is required.' }],
        ageEnd: [{ type: 'required', message: 'Age End is required.' }],
    }

    return (
        <React.Fragment>
            <JumboCardQuick
                title={
                    <Stack direction='row' alignItems='center' spacing={1}>
                        <IconButton
                            className='backArrowForm'
                            onClick={() =>
                                navigate(`/settings/definitions/age-group`, {
                                    state: { navigateFrom: 'cancel-add-age-group' },
                                })
                            }>
                            <WestIcon />
                        </IconButton>
                        <Typography color={'common.white'} variant={'h3'} sx={{ mt: 0.8 }}>
                            Add Group Name
                        </Typography>
                    </Stack>
                }
                headerSx={{
                    height: 40,
                    bgcolor: 'primary.main',
                }}>
                <div>
                    <form onSubmit={handleSubmit(props.addAgeGroup)}>
                        <Form
                            mode='form'
                            formData={props.AgeGroupData}
                            showColonAfterLabel={false}
                            showValidationSummary={false}
                            labelLocation={labelLocation}>
                            <GroupItem caption='New Age Group' cssClass='form-group-item'>
                                <ColCountByScreen lg={13} md={13} sm={1} xs={1} />
                                <GroupItem />
                                <GroupItem />
                                <GroupItem />
                                <GroupItem cssClass='form-group-item' colSpan={6}>
                                    <EmptyItem />
                                    <SimpleItem dataField='ageGroupName' validationRules={validationRules.ageGroupName}>
                                        <Label text='Age Group Name' />
                                    </SimpleItem>
                                    <SimpleItem
                                        dataField='ageStart'
                                        editorType='dxNumberBox'
                                        editorOptions={{ showSpinButtons: 'true', min: 0 }}
                                        validationRules={validationRules.ageStart}>
                                        <Label text='Age Start (years)' />
                                    </SimpleItem>
                                    <SimpleItem
                                        dataField='ageStartMonths'
                                        editorType='dxNumberBox'
                                        editorOptions={{ showSpinButtons: 'true', min: 0, max: 11 }}
                                        validationRules={[{ type: 'range', min: 0, max: 11, message: 'Age Start months must be 0–11.' }]}>
                                        <Label text='Age Start (months)' />
                                    </SimpleItem>                                    
                                    <SimpleItem
                                        dataField='ageEnd'
                                        editorType='dxNumberBox'
                                        editorOptions={{ showSpinButtons: 'true', min: 0 }}
                                        validationRules={validationRules.ageEnd}>
                                        <Label text='Age End (years)' />
                                    </SimpleItem>
                                    <SimpleItem
                                        dataField='ageEndMonths'
                                        editorType='dxNumberBox'
                                        editorOptions={{ showSpinButtons: 'true', min: 0, max: 11 }}
                                        validationRules={[{ type: 'range', min: 0, max: 11, message: 'Age End months must be 0–11.' }]}>
                                        <Label text='Age End (months)' />
                                    </SimpleItem>
                                    <SimpleItem
                                        dataField='displayOrder'
                                        editorType='dxNumberBox'
                                        editorOptions={{ showSpinButtons: 'true' }}>
                                        <Label text='Sort Order' />
                                    </SimpleItem>
                                    <SimpleItem dataField='comments' editorType='dxTextArea' />
                                </GroupItem>
                            </GroupItem>
                            <EmptyItem />
                            <GroupItem>
                                <ColCountByScreen lg={2} md={2} sm={2} xs={2} />
                                <ButtonItem
                                    buttonOptions={{
                                        disabled: loading,
                                        icon: loading ? 'refresh' : 'check',
                                        ...submitButtonOptions,
                                    }}
                                    horizontalAlignment='right'
                                />
                                <ButtonItem buttonOptions={cancelButtonOptions} horizontalAlignment='left' />
                            </GroupItem>
                        </Form>
                    </form>
                </div>
            </JumboCardQuick>
        </React.Fragment>
    )
}

export default AddAgeGroupForm
